import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { User } from 'lib/generated/graphql';
import { useState } from 'react';
import { Divider } from 'src/shared-components/';

const CheckoutForm = ({
  onSuccess,
  setIsLoading,
  lead,
}: {
  onSuccess: () => void;
  setIsLoading?: (bool) => void;
  lead: User;
}) => {
  const stripe = useStripe();
  const elements = useElements();

  const huddleFee = 0.1;
  const huddleMarkup = 1.25;

  const [errorMessage, setErrorMessage] = useState(null);
  const curr = (value: number) => {
    return value.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const handleSubmit = async event => {
    setIsLoading(true);
    event.preventDefault();

    if (!stripe || !elements) return;

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: { return_url: process.env.NEXT_PUBLIC_APP_URL },
      redirect: 'if_required',
    });

    if (error) {
      setErrorMessage(error.message);
      setIsLoading(false);
    } else {
      onSuccess();
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="px-2 text-lg">
        <div className="flex">
          <span>Builder Rate</span>
          <span className="ml-auto">{curr(lead.builderOnboarding.minimumRate * huddleMarkup)}</span>
        </div>
        <div className="flex">
          <span>Platform Fee</span>
          <span className="ml-auto">{curr(lead.builderOnboarding.minimumRate * huddleMarkup * huddleFee)}</span>
        </div>
        <div className="flex font-bold">
          <span className="">Total</span>
          <span className="ml-auto">{curr(lead.builderOnboarding.minimumRate * huddleMarkup * (1 + huddleFee))}</span>
        </div>
      </div>
      <div className="min-h-[300px] flex flex-col justify-center">
        <PaymentElement />
      </div>
      <Divider className="w-19/20 my-4" />
      <div className="items-center justify-center flex">
        <button
          className="w-full h-[55px] place-items-center flex justify-center text-center rounded-lg flex-shrink-0 bg-black"
          disabled={!stripe}
        >
          <p className="text-white">Pay</p>
        </button>
      </div>
      <div className="py-2">{errorMessage && <div>{errorMessage}</div>}</div>
    </form>
  );
};

export default CheckoutForm;
